module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/spot_dummy-82be4e721645d88fed9268ed5619cd27.jpg";